import { CmsThemes } from 'src/lib/constants';

export const gridCardStyles = ({ cmsTheme, isDark, backgroundColor }) => {
  return (
    {
      [CmsThemes.WEB2]: {
        borderRadius: '20px',
        border: 1,
        borderColor: isDark ? 'white' : 'black',
        backgroundColor: 'transparent',
      },
      [CmsThemes.WEB3]: {
        borderRadius: '17px',
        background: (theme) => {
          return theme.palette[backgroundColor] || backgroundColor;
        },
      },
    }[cmsTheme] || {}
  );
};
